// hooks/useValidationFlag.js
const KEY = 'viaValidation';

export const useValidationFlag = () => {
  const set = () => sessionStorage.setItem(KEY, 'true');
  const clear = () => sessionStorage.removeItem(KEY);
  const isSet = () => sessionStorage.getItem(KEY) === 'true';
  return { set, clear, isSet };
};